
// 刘硕
// app启动页、收入明细、自退广、客诉中心、隐私协议、历史路由（为兼容老版本保留）

const routers = [
  // app启动页（空白页）
  {
    path: '/app-on',
    name: 'appOn',
    component: () => import(/* webpackChunkName: "app-on" */ './views/app-on.vue'),
  },
  // 收入明细
  {
    path: '/user-balance',
    name: 'userBalance',
    component: () =>
      import(/* webpackChunkName: "user-balance" */ './views/user-balance.vue'),
  },
  // 陪玩师自退广设置
  {
    path: '/recommend-self',
    name: 'recommendSelf',
    component: () =>
      import(
        /* webpackChunkName: "recommend-self" */ './views/recommend-self.vue'
      ),
  },
  // 客诉中心 & 隐私协议等
  {
    path: '/resolution-center',
    name: 'resolutionCenter',
    component: () =>
      import(
        /* webpackChunkName: "resolution-center" */ './views/resolution-center.vue'
      ),
  },
  {
    path: '/user-agreement',
    name: 'userAgreement',
    component: () =>
      import(
        /* webpackChunkName: "user-agreement" */ './views/user-agreement.vue'
      ),
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () =>
      import(
        /* webpackChunkName: "privacy-policy" */ './views/privacy-policy.vue'
      ),
  },
  {
    path: '/privacy-ios',
    name: 'privacyIos',
    component: () =>
      import(
        /* webpackChunkName: "privacy-policy" */ './views/privacy-ios.vue'
      ),
  },
  {
    path: '/waveeplay-privacy-ios',
    name: 'privacyIosWaveeplay',
    component: () =>
      import(
        /* webpackChunkName: "privacy-policy" */ './views/privacy-ios-waveeplay.vue'
      ),
  },
]

export default routers
